import I18nMessage from './I18nMessage';


export default I18nMessage;
